import * as React from 'react';
import { CaptionTypography, H4Typography } from 'ui';

type Props = {
	title: string;
	subtitle?: string;
};

export const Header: React.FC<Props> = ({ title, subtitle }) => {
	return (
		<header className="flex flex-col gap-20" data-testid="auth-header">
			<H4Typography className="text-center">{title}</H4Typography>
			{subtitle && <CaptionTypography truncate={false}>{subtitle}</CaptionTypography>}
		</header>
	);
};
